module.exports = __webpack_public_path__ + "static/img/face13.16f59cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/faces/face13.jpg
// module id = 7xIX
// module chunks = 0